export const emptyMessageStyles = {
  padding: '16px',
};
